/**
 * @author Muhammad Fahad
 * @datetime April, 18th 2022
 * @description: This directive is for control disable through that we will disable
 *                controls for unauthorized users
 */
import { Directive, ElementRef, Input } from '@angular/core';
import { HelperService } from 'src/app/shared/utils/helper.service';
import {
  activeRoles,
  Page,
  UserRoleAccessControl,
} from 'src/app/shared/utils/user-roles';

@Directive({
  selector: '[controlDisabled]',
})
export class ControlDisabledDirective {
  userRole = this.helperService.getUserRole;

  /**
   * @description contructor for injecting services
   * @param { HelperService } helperService helper service for reading user role and other information
   * @param { ElementRef } el reference of current element to set diabled property
   */
  constructor(private helperService: HelperService, private el: ElementRef) {}

  /**
   * @description this is setter method that will be call when HTML element will
   *              be rendered every time
   * @param { String[] } right this array contains page name and operation name i.e [ pageName, operationName ]
   *                          where operation name can be CREATE/UPDATE/VIEW/DELETE
   */
  @Input() set controlDisabled(right: string[]) {
    let accessControls1: any;
    if (activeRoles.includes(this.userRole)) {
      const pages: Page[] = this.helperService.getUserAccessibilityMatrix;
      accessControls1 = pages?.find((page) => page.name === right[0]);
    } else {
      accessControls1 = UserRoleAccessControl.find(
        (user) => user.roleName === this.userRole
      )?.pages.find((page) => page.name === right[0]);
    }

    if (!accessControls1) {
      accessControls1 = UserRoleAccessControl.find(
        (user) => user.roleName === this.userRole
      )?.pages.find((page) => page.name === right[0]);
    }

    if (accessControls1 && accessControls1[right[1]]) {
      this.el.nativeElement.disabled = false;
      this.el.nativeElement.permDisabled = false;
    } else {
      this.el.nativeElement.disabled = true;
      this.el.nativeElement.permDisabled = true;
    }
  }

  /**
   * @description this directive overrides [disabled] property when accessControl directive is added
   * @param { boolean } condition boolean condition for enable or disable control.
   */
  @Input() set disabledCheck(condition: boolean) {
    if (this.el?.nativeElement?.permDisabled)
      this.el.nativeElement.disabled = true;
    else this.el.nativeElement.disabled = condition;
  }
}
